module.exports = __webpack_public_path__ + "static/media/20240207165354_IMG_5309.a9e63cef.JPG";